// area codes that expose a KPIs tab on the area node
export const kpiAreaCodes = ['06', '20', '25', '30', '40', '45', '50', '60']

// areaCode_departmentCode
export const areaDepartmentCodes = [
  '20_1',
  '20_4',
  '25_1',
  '30_4',
  '40_4',
  '45_1',
  '50_4',
  '60_4',
  '06_4',
  '41_1',
  '45_0',
  '60_6'
]
